import { NavLink } from 'react-router-dom';

/**
 * The places a customer's own data lives. Kept separate from PublicNav
 * because the account header answers a different question ("where am I in my
 * stuff?") than the public one ("what does this business do?").
 */

const ACCOUNT_ITEMS = [
  { label: 'Ringkasan', to: '/akun', end: true },
  { label: 'Pesanan', to: '/akun/pesanan', end: false },
  { label: 'Penawaran', to: '/akun/penawaran', end: false },
  { label: 'Lisensi', to: '/akun/lisensi', end: false },
  { label: 'Pengaturan', to: '/akun/pengaturan', end: false },
];

export function AccountNav({ className = '' }: { className?: string }) {
  return (
    <nav aria-label="Navigasi akun" className={`flex items-center gap-[26px] ${className}`}>
      {ACCOUNT_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            `inline-flex min-h-[44px] items-center text-[15px] font-bold no-underline transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink ${
              isActive ? 'text-ink' : 'text-body hover:text-ink'
            }`
          }
        >
          {({ isActive }) => (
            <span className={isActive ? 'border-b-[2.5px] border-ink pb-[3px]' : ''}>{item.label}</span>
          )}
        </NavLink>
      ))}
    </nav>
  );
}

export default AccountNav;
